import { render, staticRenderFns } from "./FeedbackStatByFailureTypeWithRma.vue?vue&type=template&id=06763a27&"
import script from "./FeedbackStatByFailureTypeWithRma.vue?vue&type=script&lang=js&"
export * from "./FeedbackStatByFailureTypeWithRma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports